<template>
    <div class="overlay-frame">
        <div class="overlay-panel" v-bind:style="maxWidthVal">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'OverlayFrame',
        props: [ 'maxWidth' ],
        computed : {
            maxWidthVal(){
                const m = this.maxWidth
                return m ? { maxWidth : m } : {}
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../scss/vars";

    .overlay{
        &-frame{
            background: rgba( 0, 0, 0, 0.8 );
            position: fixed;
            padding: 1.4rem;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            z-index: 50;
            overflow: auto;
        }
        &-panel{
            background: white;
            box-shadow: 0 5px 10px rgba( 0, 0, 0, 0.5 );
            min-height: 300px;
            padding: 0.4rem;
            max-width: 600px;
            margin: 0 auto;
            position: relative;
            border-radius: $radius;
            @media screen and (min-width: $b1){
                padding: 2rem;
            }
        }
    }
    
</style>